import { struct, union } from 'io-ts/Decoder';

import { RequestData } from './RequestData';

export const Request = union(
	struct({
		data: RequestData,
	})
);
